import { render } from "./manage_promotion_form.vue?vue&type=template&id=1d810dc5&scoped=true"
import script from "./manage_promotion_form.vue?vue&type=script&lang=js"
export * from "./manage_promotion_form.vue?vue&type=script&lang=js"

import "./manage_promotion_form.vue?vue&type=style&index=0&id=1d810dc5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d810dc5"]])

export default __exports__